import { PropertyRecordsModel } from "property_records/models/page";

(function Page(PROPERTY_RECORDS) {

  var init = function (options) {
    var data = (options || {}).data || MOVE.DataStore.getData('propertyRecords');
    PROPERTY_RECORDS.model = new PropertyRecordsModel(options || {data: data});
  };

  PROPERTY_RECORDS.page = {
    init: init
  };

})(MOVE.PropertyRecords);



// WEBPACK FOOTER //
// ./property_records/controllers/page.js